/**
 * Normaliza string (remove acentos, espaços → hífen, lowercase).
 * Espelha helpers/utils.js → sanitizeString da garagem.
 */
const sanitizeString = (value: string | undefined): string | undefined => {
	if (!value) return undefined;
	return value
		.toString()
		.normalize('NFD')
		.replace(/[̀-ͯ](?=\B)|([^\w-](?=\B))/g, '')
		.trim()
		.split(' ')
		.join('-')
		.toLowerCase()
		.replace(/[̀-ͯ]|([^\w-])/g, '');
};

const getQueryStringParameter = (parameterName: string, url?: string): string | undefined => {
	if (typeof window === 'undefined') return undefined;
	const target = url ?? window.location.href;
	const escaped = parameterName.replace(/[[\]]/g, '\\$&');
	const regex = new RegExp(`[?&]${escaped}(=([^&#]*)|&|#|$)`);
	const results = regex.exec(target);
	if (!results) return undefined;
	if (!results[2]) return '';
	return results[2];
};

const buildTier = (pageName: string, tier: number): Record<string, string> => {
	if (!tier || tier <= 0) return {};
	const segments = pageName.split('/').slice(-tier);
	return segments.reduce<Record<string, string>>((acc, segment, index) => {
		acc[`pageNameTier${index + 1}`] = segment;
		return acc;
	}, {});
};

const detectPlatform = (): 'mobile' | 'desktop' => {
	if (typeof window === 'undefined') return 'desktop';
	return window.screen?.width <= 768 ? 'mobile' : 'desktop';
};

export { sanitizeString, getQueryStringParameter, buildTier, detectPlatform };
